import TelesoftSyncManager from './TelesoftSyncManager.js';
import UnitSyncManager from './UnitSyncManager.js';
import UniticketingSyncManager from './UniticketingSyncManager.js';
import OrderSyncManager from './OrderSyncManager.js';

export default class BackofficeEntitiesForm {

  constructor() {
    this.telesoftSync = new TelesoftSyncManager();
    this.unitSync = new UnitSyncManager();
    this.uniticketingSync = new UniticketingSyncManager();
    this.orderSync = new OrderSyncManager();
    this.isUnitSyncProcessing = false;
    this.unitModalCloseButton = null;
    this.isUniticketingSyncProcessing = false;
    this.uniticketingModalCloseButton = null;
    this.bindEvents();
    this.initSelect2();
    this.initTelesoftSyncModal();
    this.initUnitSyncModal();
    this.initUniticketingSyncModal();
    this.initOrderSyncWidget();
    this.initForceUpdateUnitFields();
    this.initSyncOrdersModal();
  }

  bindEvents() {
    // No specific form interactions needed for now
    // Can be extended later if needed
  }

  initSelect2() {
    // Initialize select2 for manager selects with search functionality
    $('#entity_technical_manager_id').select2({
      placeholder: 'Sélectionner un gestionnaire technique',
      allowClear: true,
      width: '100%'
    });

    $('#entity_accounting_manager_id').select2({
      placeholder: 'Sélectionner un gestionnaire comptable',
      allowClear: true,
      width: '100%'
    });
  }

  initTelesoftSyncModal() {
    const $modal = $('#telesoftSyncModal');
    if (!$modal.length) return;

    // Reset modal state when opened
    $modal.on('show.bs.modal', () => {
      this.resetModalState();
    });

    // Handle confirm button click
    $('#confirm-sync-btn').on('click', () => {
      this.performSyncCheck();
    });

    // Handle update button click
    $('#confirm-update-btn').on('click', () => {
      this.performUpdate();
    });
  }

  initUnitSyncModal() {
    const $modal = $('#unitSyncModal');
    if (!$modal.length) return;

    this.unitModalCloseButton = $modal.find('.close');

    $modal.on('show.bs.modal', () => {
      this.resetUnitModalState();
    });

    $modal.on('hide.bs.modal', (event) => {
      if (this.isUnitSyncProcessing) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    });

    $('#unit-confirm-sync-btn').on('click', () => {
      this.performUnitSync();
    });
  }

  initUniticketingSyncModal() {
    const $modal = $('#uniticketingSyncModal');
    if (!$modal.length) return;

    this.uniticketingModalCloseButton = $modal.find('.close');

    $modal.on('show.bs.modal', () => {
      this.resetUniticketingModalState();
    });

    $modal.on('hide.bs.modal', (event) => {
      if (this.isUniticketingSyncProcessing) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    });

    $('#uniticketing-confirm-sync-btn').on('click', () => {
      this.performUniticketingSync();
    });
  }

  resetUniticketingModalState() {
    this.isUniticketingSyncProcessing = false;
    this.enableUniticketingCloseControls();
    $('#uniticketing-sync-initial').show();
    $('#uniticketing-sync-processing').hide();
    $('#uniticketing-sync-success').hide();
    $('#uniticketing-sync-error').hide();
    $('#uniticketing-sync-error-message').text('');

    $('#uniticketing-confirm-sync-btn').show().prop('disabled', false);
    $('#uniticketing-modal-cancel-btn').show();
    $('#uniticketing-modal-close-btn').hide();
  }

  showUniticketingProcessingState() {
    this.isUniticketingSyncProcessing = true;
    $('#uniticketing-sync-initial').hide();
    $('#uniticketing-sync-error').hide();
    $('#uniticketing-sync-processing').show();
    $('#uniticketing-confirm-sync-btn').prop('disabled', true);
    $('#uniticketing-modal-cancel-btn').hide();
    this.disableUniticketingCloseControls();
  }

  showUniticketingResultState(type, message = '') {
    $('#uniticketing-sync-processing').hide();
    this.isUniticketingSyncProcessing = false;

    if (type === 'success') {
      $('#uniticketing-sync-success').show();
      $('#uniticketing-sync-error').hide();
      this.hideUniticketingActionButtons();
      this.enableUniticketingCloseControls();
    } else {
      $('#uniticketing-sync-success').hide();
      $('#uniticketing-sync-error').show();
      $('#uniticketing-sync-error-message').text(message);
      $('#uniticketing-confirm-sync-btn').show().prop('disabled', false);
      $('#uniticketing-modal-cancel-btn').show();
      $('#uniticketing-modal-close-btn').hide();
      this.enableUniticketingCloseControls();
    }
  }

  hideUniticketingActionButtons() {
    $('#uniticketing-confirm-sync-btn').hide();
    $('#uniticketing-modal-cancel-btn').hide();
    $('#uniticketing-modal-close-btn').show();
  }

  disableUniticketingCloseControls() {
    if (this.uniticketingModalCloseButton) {
      this.uniticketingModalCloseButton.prop('disabled', true).addClass('disabled').css('pointer-events', 'none');
    }
  }

  enableUniticketingCloseControls() {
    if (this.uniticketingModalCloseButton) {
      this.uniticketingModalCloseButton.prop('disabled', false).removeClass('disabled').css('pointer-events', '');
    }
  }

  resetModalState() {
    // Show initial content
    $('#sync-initial-content').show();
    $('#sync-checking').hide();
    $('#sync-processing').hide();
    $('#sync-updating').hide();
    $('#sync-already-exists').hide();
    $('#sync-success').hide();
    $('#sync-update-success').hide();
    $('#sync-error').hide();
    
    // Show/hide buttons
    $('#confirm-sync-btn').show().prop('disabled', false);
    $('#confirm-update-btn').hide();
    $('#modal-cancel-btn').show();
    $('#modal-close-btn').hide();
  }

  showCheckingState() {
    $('#sync-initial-content').hide();
    $('#sync-checking').show();
    $('#confirm-sync-btn').prop('disabled', true);
  }

  showProcessingState() {
    $('#sync-checking').hide();
    $('#sync-processing').show();
  }

  showUpdatingState() {
    $('#sync-already-exists').hide();
    $('#sync-updating').show();
  }

  showResultState(type, message = '') {
    $('#sync-processing').hide();
    $('#sync-checking').hide();
    $('#sync-updating').hide();
    
    if (type === 'exists') {
      $('#sync-already-exists').show();
      // Show update button and hide sync button
      $('#confirm-sync-btn').hide();
      $('#confirm-update-btn').show();
    } else if (type === 'success') {
      $('#sync-success').show();
      this.hideActionButtons();
    } else if (type === 'update-success') {
      $('#sync-update-success').show();
      this.hideActionButtons();
    } else if (type === 'error') {
      $('#sync-error').show();
      $('#sync-error-message').text(message);
      this.hideActionButtons();
    }
  }

  hideActionButtons() {
    $('#confirm-sync-btn').hide();
    $('#confirm-update-btn').hide();
    $('#modal-cancel-btn').hide();
    $('#modal-close-btn').show();
  }

  resetUnitModalState() {
    this.isUnitSyncProcessing = false;
    this.enableUnitCloseControls();
    $('#unit-sync-initial').show();
    $('#unit-sync-processing').hide();
    $('#unit-sync-success').hide();
    $('#unit-sync-error').hide();
    $('#unit-sync-error-message').text('');

    $('#unit-confirm-sync-btn').show().prop('disabled', false);
    $('#unit-modal-cancel-btn').show();
    $('#unit-modal-close-btn').hide();
  }

  showUnitProcessingState() {
    this.isUnitSyncProcessing = true;
    $('#unit-sync-initial').hide();
    $('#unit-sync-error').hide();
    $('#unit-sync-processing').show();
    $('#unit-confirm-sync-btn').prop('disabled', true);
    $('#unit-modal-cancel-btn').hide();
    this.disableUnitCloseControls();
  }

  showUnitResultState(type, message = '') {
    $('#unit-sync-processing').hide();

    if (type === 'success') {
      this.isUnitSyncProcessing = false;
      $('#unit-sync-success').show();
      $('#unit-sync-error').hide();
      this.hideUnitActionButtons();
      this.enableUnitCloseControls();
    } else if (type === 'error') {
      this.isUnitSyncProcessing = false;
      $('#unit-sync-success').hide();
      $('#unit-sync-error').show();
      $('#unit-sync-error-message').text(message);
      $('#unit-confirm-sync-btn').show().prop('disabled', false);
      $('#unit-modal-cancel-btn').show();
      $('#unit-modal-close-btn').hide();
      this.enableUnitCloseControls();
    }
  }

  hideUnitActionButtons() {
    $('#unit-confirm-sync-btn').hide();
    $('#unit-modal-cancel-btn').hide();
    $('#unit-modal-close-btn').show();
  }

  disableUnitCloseControls() {
    if (this.unitModalCloseButton) {
      this.unitModalCloseButton.prop('disabled', true).addClass('disabled').css('pointer-events', 'none');
    }
  }

  enableUnitCloseControls() {
    if (this.unitModalCloseButton) {
      this.unitModalCloseButton.prop('disabled', false).removeClass('disabled').css('pointer-events', '');
    }
  }

  performSyncCheck() {
    this.showCheckingState();
    
    const $modal = $('#telesoftSyncModal');
    
    // Use TelesoftSyncManager with modal data attributes
    this.telesoftSync.checkSingleEntity($modal)
    .done((data) => {
      if (data.exists) {
        this.showResultState('exists');
        $("#telesoft-id").val(data.telesoftId);
      } else {
        // Customer doesn't exist, proceed with sync
        this.performSync();
      }
    })
    .fail((xhr, status, error) => {
      console.error('Error checking customer:', error);
      this.showResultState('error', 'Erreur lors de la vérification du client.');
    });
  }

  performSync() {
    this.showProcessingState();
    
    const $modal = $('#telesoftSyncModal');
    
    // Use TelesoftSyncManager with modal data attributes
    this.telesoftSync.syncSingleEntity($modal)
    .done((data) => {
      if (data.success) {
        this.showResultState('success');
      } else {
        this.showResultState('error', data.error || 'Erreur inconnue lors de la synchronisation.');
      }
    })
    .fail((xhr, status, error) => {
      console.error('Error syncing:', error);
      this.showResultState('error', 'Erreur lors de la synchronisation avec Telesoft.');
    });
  }

  performUpdate() {
    this.showUpdatingState();
    
    const $modal = $('#telesoftSyncModal');
    
    // Use TelesoftSyncManager with modal data attributes
    this.telesoftSync.updateSingleEntity($modal)
    .done((data) => {
      if (data.success) {
        this.showResultState('update-success');
      } else {
        this.showResultState('error', data.error || 'Erreur inconnue lors de la mise à jour.');
      }
    })
    .fail((xhr, status, error) => {
      console.error('Error updating:', error);
      this.showResultState('error', 'Erreur lors de la mise à jour dans Telesoft.');
    });
  }

  performUnitSync() {
    this.showUnitProcessingState();

    const $modal = $('#unitSyncModal');

    this.unitSync.syncSingleEntity($modal)
    .done((data) => {
      if (data.success) {
        this.showUnitResultState('success');
        const $trigger = $('#unit-sync-btn');
        if ($trigger.length) {
          $trigger
            .removeClass('btn-info')
            .addClass('btn-success')
            .prop('disabled', true)
            .attr('title', 'Déjà synchronisée sur UniT')
            .html('<i class="mdi mdi-check mr-1"></i>Synchronisée sur UniT')
            .removeAttr('data-toggle')
            .removeAttr('data-target');
        }
      } else {
        this.showUnitResultState('error', data.error || 'Erreur inconnue lors de la synchronisation UniT.');
      }
    })
    .fail((xhr, status, error) => {
      console.error('Error syncing UniT:', error);
      this.showUnitResultState('error', 'Erreur lors de la synchronisation avec UniT.');
    });
  }

  performUniticketingSync() {
    this.showUniticketingProcessingState();

    const $modal = $('#uniticketingSyncModal');

    this.uniticketingSync.syncSingleEntity($modal)
    .done((data) => {
      if (data.success) {
        this.showUniticketingResultState('success');
        const $trigger = $('#uniticketing-sync-btn');
        if ($trigger.length) {
          $trigger
            .removeClass('btn-info')
            .addClass('btn-success')
            .prop('disabled', true)
            .attr('title', 'Déjà synchronisée sur Uniticketing')
            .html('<i class="mdi mdi-check mr-1"></i>Synchronisée sur Uniticketing')
            .removeAttr('data-toggle')
            .removeAttr('data-target');
        }
      } else {
        this.showUniticketingResultState('error', data.error || 'Erreur inconnue lors de la synchronisation Uniticketing.');
      }
    })
    .fail((xhr, status, error) => {
      console.error('Error syncing Uniticketing:', error);
      this.showUniticketingResultState('error', 'Erreur lors de la synchronisation avec Uniticketing.');
    });
  }

  // --- Order Sync Widget ---

  initOrderSyncWidget() {
    const $selectAll = $('#order-sync-select-all');
    if (!$selectAll.length) return;

    $selectAll.on('change', () => {
      const checked = $selectAll.is(':checked');
      $('.order-sync-checkbox').prop('checked', checked);
      this.updateSyncButtonState();
    });

    $(document).on('change', '.order-sync-checkbox', () => {
      this.updateSyncButtonState();
      const allChecked = $('.order-sync-checkbox').length === $('.order-sync-checkbox:checked').length;
      $selectAll.prop('checked', allChecked);
    });
  }

  updateSyncButtonState() {
    const anyChecked = $('.order-sync-checkbox:checked').length > 0;
    $('#sync-selected-orders-btn').prop('disabled', !anyChecked);
  }

  getSelectedOrderIds() {
    return $('.order-sync-checkbox:checked').map(function () {
      return $(this).val();
    }).get();
  }

  // --- Force Update Unit Identifiers (inline edit) ---

  initForceUpdateUnitFields() {
    const $btn = $('#force-update-unit-btn');
    const $saveBtn = $('#save-unit-ids-btn');
    if (!$btn.length) return;

    $btn.on('click', () => {
      this.toggleUnitIdFields(true);
    });

    $saveBtn.on('click', () => {
      this.saveUnitIds();
    });
  }

  toggleUnitIdFields(editable) {
    $('.unit-id-field').prop('disabled', !editable);
    $('#force-update-unit-btn').toggle(!editable);
    $('#save-unit-ids-btn').toggle(editable);
  }

  saveUnitIds() {
    const $saveBtn = $('#save-unit-ids-btn');
    const saveUrl = $saveBtn.data('save-url');
    const incidentsCustomerId = $('#unit-incidents-customer-id').val();

    $saveBtn.prop('disabled', true).html('<i class="mdi mdi-loading mdi-spin mr-1"></i>Enregistrement...');

    $.ajax({
      url: saveUrl,
      method: 'PUT',
      dataType: 'json',
      headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
      data: {
        entity: {
          incidents_customer_id: incidentsCustomerId
        }
      }
    })
      .done((data) => {
        if (data.success) {
          this.toggleUnitIdFields(false);
        } else {
          alert(data.errors || 'Erreur lors de la sauvegarde.');
        }
      })
      .fail(() => {
        alert('Erreur lors de la sauvegarde des identifiants UniT.');
      })
      .always(() => {
        $saveBtn.prop('disabled', false).html('<i class="mdi mdi-content-save mr-1"></i>Enregistrer');
      });
  }

  // --- Sync Orders Modal ---

  initSyncOrdersModal() {
    const $modal = $('#syncOrdersModal');
    if (!$modal.length) return;

    $modal.on('show.bs.modal', () => {
      this.resetSyncOrdersModal();
      this.populateSyncOrdersList();
    });

    $('#sync-orders-confirm-btn').on('click', () => {
      this.performSyncOrders();
    });
  }

  resetSyncOrdersModal() {
    $('#sync-orders-initial').show();
    $('#sync-orders-processing').hide();
    $('#sync-orders-success').hide();
    $('#sync-orders-error').hide();
    $('#sync-orders-confirm-btn').show().prop('disabled', false);
    $('#sync-orders-cancel-btn').show();
    $('#sync-orders-close-btn').hide();
  }

  populateSyncOrdersList() {
    const $list = $('#sync-orders-list');
    $list.empty();
    $('.order-sync-checkbox:checked').each(function () {
      const sn = $(this).data('service-number');
      $list.append(`<li>${sn}</li>`);
    });
  }

  performSyncOrders() {
    const $modal = $('#syncOrdersModal');
    const syncUrl = $modal.data('sync-orders-url');
    const orderIds = this.getSelectedOrderIds();

    $('#sync-orders-initial').hide();
    $('#sync-orders-processing').show();
    $('#sync-orders-confirm-btn').prop('disabled', true);
    $('#sync-orders-cancel-btn').hide();

    this.orderSync.syncOrders(syncUrl, orderIds)
      .done((data) => {
        $('#sync-orders-processing').hide();
        if (data.success) {
          $('#sync-orders-success').show();
          $('#sync-orders-success-message').text(data.message || 'Synchronisation réussie.');
          this.updateOrderBadges(data.details || []);
        } else {
          $('#sync-orders-error').show();
          $('#sync-orders-error-message').text(data.error || 'Erreur inconnue');
          if (data.details) {
            this.updateOrderBadges(data.details);
          }
        }
        this.showSyncOrdersCloseButtons();
      })
      .fail((xhr, status, error) => {
        console.error('Error syncing orders:', error);
        $('#sync-orders-processing').hide();
        $('#sync-orders-error').show();
        $('#sync-orders-error-message').text('Erreur lors de la synchronisation des commandes.');
        this.showSyncOrdersCloseButtons();
      });
  }

  updateOrderBadges(details) {
    for (const detail of details) {
      if (detail.success) {
        const $badge = $(`#order-sync-badge-${detail.order_id}`);
        $badge.removeClass('badge-danger').addClass('badge-success')
          .html('<i class="mdi mdi-check mr-1"></i>Synced');
      }
    }
    $('.order-sync-checkbox').prop('checked', false);
    $('#order-sync-select-all').prop('checked', false);
    this.updateSyncButtonState();
  }

  showSyncOrdersCloseButtons() {
    $('#sync-orders-confirm-btn').hide();
    $('#sync-orders-cancel-btn').hide();
    $('#sync-orders-close-btn').show();
  }

  onDataChanged(data) {
  }

  onDestroy() {
    // Destroy select2 instances
    if ($('#entity_technical_manager_id').hasClass('select2-hidden-accessible')) {
      $('#entity_technical_manager_id').select2('destroy');
    }
    if ($('#entity_accounting_manager_id').hasClass('select2-hidden-accessible')) {
      $('#entity_accounting_manager_id').select2('destroy');
    }

    $('#telesoftSyncModal').off('show.bs.modal');
    $('#confirm-sync-btn').off('click');
    $('#confirm-update-btn').off('click');
    $('#unitSyncModal').off('show.bs.modal');
    $('#unitSyncModal').off('hide.bs.modal');
    $('#unit-confirm-sync-btn').off('click');
    $('#uniticketingSyncModal').off('show.bs.modal');
    $('#uniticketingSyncModal').off('hide.bs.modal');
    $('#uniticketing-confirm-sync-btn').off('click');
    $('#forceUpdateUnitModal').off('show.bs.modal');
    $('#force-update-unit-btn').off('click');
    $('#save-unit-ids-btn').off('click');
    $('#syncOrdersModal').off('show.bs.modal');
    $('#sync-orders-confirm-btn').off('click');
    $(document).off('change', '.order-sync-checkbox');
    $('#order-sync-select-all').off('change');
  }
}